export default "__VITE_ASSET__1x2VR2dy__"